<script>
/* eslint-disable */
import { mapGetters } from "vuex";
export default {
  name: "ProductionFields",
  props: ["activity", "field"],
  data() {
    return {
      post_production_data: {
        activity: null,
        filmed: false,
        rough_cut: null,
        review: null,
        final_cut: null,
        colour_grade: null,
        timer: null,
        file_location: "",
        project_location: "",
        edit_notes: "",
      },
      n_activity: this.activity ? this.activity : {},
      options: {},
    };
  },
  computed: {
    ...mapGetters({
      fieldOptionsChunked: "commons/fieldOptionsChunked",
      locationsOptions: "commons/locationsOptions",
      reviewOptions: "commons/reviewOptions",
      roughCutOptions: "commons/roughCutOptions",
      finalCutOptions: "commons/finalCutOptions",
      audioOptions: "commons/audioOptions",
      currentActivity: "commons/currentActivity",
      coloursOptions: "commons/coloursOptions",
      post_production: "commons/post_production",
      userFieldOption: "commons/userFieldOption",
      colourGradeOptions: "commons/colourGradeOptions",
      seriesOptions: "commons/seriesOptions",
    }),
    roughCutOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.roughCutOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },
    userFieldOptionRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.userFieldOption.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },

    reviewOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.reviewOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },

    finalCutOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.finalCutOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },
    colourGradeOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.colourGradeOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },
    audioOptionsRemapped() {
      var options = [{ value: null, text: "Select" }];
      this.audioOptions.map((option) => {
        if (option.value != null && option.value != "") {
          options.push(option);
        }
      });
      return options;
    },
  },
  mounted() {
    this.n_activity = this.activity;
    this.options = {
      assigned: this.userFieldOptionRemapped,
      rough_cut: this.roughCutOptionsRemapped,
      review: this.reviewOptionsRemapped,
      final_cut: this.finalCutOptionsRemapped,
      colour_grade: this.colourGradeOptionsRemapped,
      audio: this.audioOptionsRemapped,
    };
  },
  methods: {
    updateProd(event) {
      this.$store.commit("commons/setPreloader", true);
      this.$store.commit(`commons/setActivity`, this.n_activity);

      if (this.n_activity.post_production) {
        this.n_activity.post_production[this.field] = event;
        this.$store.commit(
          `commons/setCurrentActivityPostProduction`,
          this.n_activity.post_production
        );

        this.$store
          .dispatch(`commons/updateSpecificProduction`, this.n_activity.id)
          .then(
            (res) => {
              if (
                this.n_activity.post_production.rough_cut &&
                this.n_activity.post_production.review &&
                this.n_activity.post_production.final_cut &&
                this.n_activity.post_production.audio
              ) {
                this.$store.commit(`commons/setActivityStatus`, "produced");
                this.$store
                  .dispatch(`commons/updateActivity`, this.n_activity.id)
                  .then(
                    (res) => {
                      this.$store.commit(`commons/setSavingForm`, "Saved");
                      this.$store.commit("commons/setPreloader", false);
                    },
                    (error) => {
                      console.log(error);
                    }
                  );
              } else {
                // this.makeToast("success", "Success", `Succesfully saved.`);
                this.$store.commit(`commons/setSavingForm`, "Saved");
                this.$store.commit("commons/setPreloader", false);
              }
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        this.post_production_data.activity = this.currentActivity.id;
        this.post_production_data[field] = event;

        this.$store.commit(
          `commons/setCurrentActivityPostProduction`,
          this.post_production_data
        );

        this.$store
          .dispatch("commons/updateProduction", this.currentActivity.id)
          .then(
            (res) => {
              // this.makeToast("success", "Success", `Succesfully saved.`);
              this.$store.commit(`commons/setSavingForm`, "Saved");
            },
            (error) => {
              console.log(error);
            }
          );
      }
    },
  },
};
</script>
<template>
  <div>
    <b-form-group class="select">
      <b-form-select
        @change="updateProd($event)"
        v-if="n_activity.post_production"
        :value="n_activity.post_production[field]"
        :options="options[field]"
      ></b-form-select>

      <b-form-select
        v-if="!n_activity.post_production"
        :options="options[field]"
        value="null"
      ></b-form-select>
    </b-form-group>
  </div>
</template>